import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useEffect, useState } from 'react';
import { Icon } from '@magalu/stereo-ui-icons';
import { oneOfType, shape, string, number, arrayOf } from 'prop-types';
import { Text } from '../../atoms';
import { checkAndCalculateTime, fetchFormattedTime, formatTimeRemainingToISO } from '../../utils';
import { LIST } from '../../constants';
import { OfferTimerContainer } from './offer-timer.styles';

const OfferTimer = _ref => {
  let {
    restrictions = {},
    height,
    fontSize,
    displayMode,
    text,
    bg
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["restrictions", "height", "fontSize", "displayMode", "text", "bg"]);

  const [timer, setTimer] = useState('');
  const [shouldRender, setShouldRender] = useState(false);
  const isDisplayModeList = displayMode === LIST;
  useEffect(() => {
    const updateTimer = () => {
      const formattedDate = fetchFormattedTime();
      const {
        show,
        timeRemainingFormatted
      } = checkAndCalculateTime(restrictions, formattedDate);
      setShouldRender(show);

      if (show) {
        setTimer(timeRemainingFormatted);
      }
    };

    const intervalId = setInterval(updateTimer, 1000);
    updateTimer();
    return () => clearInterval(intervalId);
  }, [restrictions]);
  if (!shouldRender) return null;
  return /*#__PURE__*/React.createElement(OfferTimerContainer, _extends({
    "data-testid": "offer-timer",
    borderRadius: 2,
    justifyContent: "center",
    alignItems: "center",
    bg: bg,
    height: height,
    mt: [isDisplayModeList && 1, 2],
    mr: isDisplayModeList ? '10px' : 0
  }, props), /*#__PURE__*/React.createElement(Icon, {
    color: "#FFF5F0",
    height: ['12px', '14px'],
    width: ['12px', '14px'],
    name: "Timer",
    mr: 1
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: fontSize
  }, /*#__PURE__*/React.createElement(Text, {
    color: "white",
    as: "span"
  }, text), ' ', /*#__PURE__*/React.createElement(Text, {
    color: "white",
    as: "time",
    fontWeight: "bold",
    dateTime: formatTimeRemainingToISO(timer)
  }, timer)));
};

process.env.NODE_ENV !== "production" ? OfferTimer.propTypes = {
  restrictions: shape({
    timer_end_date: string,
    timer_start_date: string
  }),
  height: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  fontSize: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  displayMode: string,
  bg: string,
  text: string
} : void 0;
OfferTimer.defaultProps = {
  height: '20px',
  fontSize: '10px',
  displayMode: LIST,
  bg: '#9110C2',
  text: 'Oferta termina em'
};
export default OfferTimer;